import { Subject } from "rxjs";
const subject = new Subject();

export const CommonLoaderService = {
  startLoading: (type, loaderText) => subject.next({ dataActive: false , type, loaderText }),
  stopLoading: () => subject.next({ dataActive: true }),
  loadingState: () => subject.asObservable(),
};
